export const EXTERNAL_PROCESS = {
  MENU: 'MENU',
  SERVER_ERROR: 'SERVER_ERROR',
  LOADING: 'LOADING',
  INITIATED: 'INITIATED',
  WAITING_REPERTORIES: 'WAITING_REPERTORIES',
  REJECTED_REQUEST_REPERTORIES: 'REJECTED_REQUEST_REPERTORIES',
  FINISHED: 'FINISHED',
  MASSIVE_TRANSFER_ASSIGN_ERROR: 'MASSIVE_TRANSFER_ASSIGN_ERROR',
  PROVIDER_ERROR: 'PROVIDER_ERROR',
};

/**
 * Maps an external repertory API response to the next UI step.
 * When needsTokenRequest is true, callers should fetch a token and use resolveStepFromTokenResponse.
 */
export function resolveExternalRepertoryOutcome(repertoriesRequestResponse) {
  if (repertoriesRequestResponse === false) {
    return { step: EXTERNAL_PROCESS.SERVER_ERROR, needsTokenRequest: false };
  }
  if (
    repertoriesRequestResponse.success === true
    && repertoriesRequestResponse.message === 'SUCCESS'
  ) {
    return { step: EXTERNAL_PROCESS.FINISHED, needsTokenRequest: false };
  }
  if (repertoriesRequestResponse.message === 'PENDING_EXTERNAL_REQUEST_PROCESS') {
    return { step: EXTERNAL_PROCESS.WAITING_REPERTORIES, needsTokenRequest: false };
  }
  if (repertoriesRequestResponse.message === 'REJECTED_EXTERNAL_REQUEST_PROCESS') {
    return { step: EXTERNAL_PROCESS.REJECTED_REQUEST_REPERTORIES, needsTokenRequest: false };
  }
  if (
    repertoriesRequestResponse.success === false
    && repertoriesRequestResponse.message === 'ACTIVE_EXTERNAL_REPERTORY_REQUEST_PROCESS_NOT_FOUND'
  ) {
    return { needsTokenRequest: true };
  }
  if (
    repertoriesRequestResponse.success === false
    && repertoriesRequestResponse.message === 'MASSIVE_TRANSFER_ASSIGN_ERROR'
  ) {
    return { step: EXTERNAL_PROCESS.MASSIVE_TRANSFER_ASSIGN_ERROR, needsTokenRequest: false };
  }
  return { step: EXTERNAL_PROCESS.SERVER_ERROR, needsTokenRequest: false };
}

export function resolveStepFromTokenResponse(tokenResponse) {
  if (!tokenResponse || !tokenResponse.status) {
    return EXTERNAL_PROCESS.SERVER_ERROR;
  }
  if (tokenResponse.status === 'pending') {
    return EXTERNAL_PROCESS.INITIATED;
  }
  if (tokenResponse.status === 'finish') {
    return EXTERNAL_PROCESS.FINISHED;
  }
  if (tokenResponse.status === 'providerError') {
    return EXTERNAL_PROCESS.PROVIDER_ERROR;
  }
  return EXTERNAL_PROCESS.SERVER_ERROR;
}
